export interface HBRadioButtonCustomTheme {
    /** Background color applied to the radio button when checked. */
    background: string;
    /** Border color for the radio button; when omitted, uses the background value. */
    color?: string;
}

export const RADIO_SIZES = {
    sm: {
        outerCircle: '16px',
        innerCircle: '6px'
    },
    md: {
        outerCircle: '20px',
        innerCircle: '8px'
    },
    lg: {
        outerCircle: '24px',
        innerCircle: '10px'
    }
} as const;
